import React from 'react';

import AssessmentIcon from '@mui/icons-material/AssessmentRounded';

import Tabs from '../../components/Tabs';
import { SUBJECTS } from '../../utils/common/constants';
import useTab from '../../utils/react/hooks/useTab';

import EnrolmentsTab from './EnrolmentsTab';
import OverviewTab from './OverviewTab';

const TABS = [
  {
    key: 'overview',
    label: 'Overview',
    icon: <AssessmentIcon />,
  },
  ...Object.values(SUBJECTS),
];

const AdminAnalyticsPage = () => {
  const [tab, setTab] = useTab({ default: TABS[0].key });

  const renderTab = () => {
    switch (tab) {
      case 'overview':
        return (
          <OverviewTab />
        );
      default:
        return (
          <EnrolmentsTab subject={tab} />
        );
    }
  };

  return (
    <>
      <Tabs
        options={TABS}
        selectedKey={tab}
        desktopDropdown
        onChange={(key) => {
          setTab(key);
        }}
      />
      {renderTab()}
    </>
  );
};
export default AdminAnalyticsPage;
